import * as stylex from '@stylexjs/stylex';
import './tokens.stylex';
import { focus } from './tokens.stylex';
export const a11y = {
  focusRing: {
    kI3sdo: "x18jyst4 xw6ncv",
    kInvED: "xea3gmg",
    $$css: true
  },
  visuallyHidden: {
    kogj98: "xkdpibf",
    kmVPX3: "x1717udv",
    ksu8eU: "xng3xce",
    kVQacm: "xb3r6kr",
    kMcinP: "xeh89do",
    kVAEAm: "x10l6tqk",
    kZKoxP: "xjm9jq1",
    kzqmXN: "x1i1rx1s",
    $$css: true
  }
};